/* eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  name: 'section-code-edit',
  components: {
    VueEditor
  },
  props: ['sectionFileID'],
  data() {
    return {
      section: "",
      file: null,
      name: '',
      description: '',
      submitted: false,
      fileid: '',
      selectedFile: '',
      id: '',
      editSectionFile: '',
      uploadFileName: '',
      code_snippet: '',
      code_language: '',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData:''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'getsectionFilesState'
    ]),
    editSectionFileFun() {
      this.$store.dispatch('get_course_section_files_id', {
        id: this.sectionFileID
      }).then((res) => {
        this.name = this.$store.getters.getsectionFilesState.data.name;
        //this.uploadFileName = this.$store.getters.getsectionFilesState.data.name;
        this.description = this.$store.getters.getsectionFilesState.data.description;
        this.selectedFile = this.$store.getters.getsectionFilesState.data.file;
        this.code_snippet = this.$store.getters.getsectionFilesState.data.code_snippet;
        this.code_language = this.$store.getters.getsectionFilesState.data.code_language;
        console.log(this.$store.getters.getsectionFilesState.data, this.file);
      }).catch((err) => {})
    },

  },
  mounted() {
    this.editSectionFileFun
    console.log(this.$store.getters.getsectionFilesState.data, 'File details ========')
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('hideEditSectionCodePopup', false);

      }).catch((err) => {})
    },
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.filesSize = this.$refs.file.files[0].size;
        this.name = this.files.name
        //this.uploadFileName = this.files.name
      }
    },
    validateFileBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let formData = new FormData();
          formData.append('description', this.description);
          formData.append('name', this.name);
          formData.append('code_snippet', this.code_snippet);
          formData.append('code_language', this.code_language);
          if (this.files) {
            formData.append('file', this.files);
          }
          //
          this.$store.dispatch('edit_course_section_files_id', {
              data: {
                formdata: formData,
                id: this.sectionFileID
              }
            })
            .then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success(res.data.msg);
              }
            })
            .catch((err) => {})
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('hideEditSectionCodePopup', false)
    },

  }
}